module.exports = __webpack_public_path__ + "img/search.035686a9.png";